export default {
  apiKey: "AIzaSyCgt3QrALTQTC4-RaKOJZLtKv2hBpA0xRw",
  authDomain: "amigo-9cc86.firebaseapp.com",
  databaseURL: "https://amigo-9cc86.firebaseio.com",
  projectId: "amigo-9cc86",
  storageBucket: "amigo-9cc86.appspot.com",
  messagingSenderId: "780212560169",
  appId: "1:780212560169:web:24897df3d7e6a42f26d738",
  measurementId: "G-31HWMLCK4F"
};